let compose=(...fns)=>(input)=>fns.reduceRight((passer,fn)=>fn(passer),input);

export {
    compose
}